import React from 'react'
import { Box, Grid, Skeleton } from '@mui/material'

const LayoutSkeleton = () => {
  return (
    <Grid
      container
      direction='column'
      justifyContent='flex-start'
      alignItems='stretch'
      spacing={2}
    >
      <Grid item>
        <Box>
          <Skeleton
            variant='rectangular'
            height='4rem'
            style={{
              borderRadius: 8
            }}
          />
        </Box>
      </Grid>
      <Grid item>
        <Box>
          <Skeleton
            variant='rectangular'
            height={118}
            style={{
              borderRadius: 8
            }}
          />
        </Box>
      </Grid>
      <Grid item>
        <Box>
          <Skeleton
            variant='rectangular'
            height={400}
            style={{
              borderRadius: 8
            }}
          />
        </Box>
      </Grid>
    </Grid>
  )
}

export default LayoutSkeleton
